var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic_off"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6362 16.3099V20C16.6362 20.9885 17.0289 21.9366 17.7279 22.6356C18.4269 23.3346 19.375 23.7273 20.3635 23.7273C21.352 23.7273 22.3001 23.3346 22.9991 22.6356C23.2543 22.3803 23.4687 22.0919 23.6381 21.7804L16.6362 16.3099ZM24.9399 22.7975C24.7207 23.156 24.4584 23.4904 24.1563 23.7925C23.1546 24.7942 21.7974 25.3588 20.3812 25.3634L20.3638 25.3633L20.3463 25.3634C18.93 25.3589 17.5728 24.7943 16.571 23.7925C15.5651 22.7866 15 21.4223 15 19.9998V18.1816C15 17.6294 14.5523 17.1816 14 17.1816C13.4477 17.1816 13 17.6294 13 18.1816V19.9998C13 21.9528 13.7758 23.8257 15.1568 25.2067C16.2999 26.3498 17.7801 27.0783 19.3638 27.2953V29H16.7271C16.1748 29 15.7271 29.4477 15.7271 30C15.7271 30.5523 16.1748 31 16.7271 31H23.9998C24.5521 31 24.9998 30.5523 24.9998 30C24.9998 29.4477 24.5521 29 23.9998 29H21.3638V27.2953C22.9473 27.0782 24.4275 26.3497 25.5705 25.2067C25.9302 24.847 26.2489 24.4539 26.5235 24.0347L24.9399 22.7975ZM27.6442 21.1032L25.7273 19.6056V18.1816C25.7273 17.6294 26.175 17.1816 26.7273 17.1816C27.2796 17.1816 27.7273 17.6294 27.7273 18.1816V19.9998C27.7273 20.3715 27.6992 20.7402 27.6442 21.1032ZM24.0908 18.327L16.6427 12.5079C16.6962 11.5994 17.0808 10.7388 17.7279 10.0917C18.4269 9.39269 19.375 9 20.3635 9C21.352 9 22.3001 9.39269 22.9991 10.0917C23.6981 10.7907 24.0908 11.7387 24.0908 12.7273V18.327Z",
    fill: "#FF5353"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    x1: 10.4037,
    y1: 10.8277,
    x2: 30.648,
    y2: 26.6442,
    stroke: "#FF5353",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic_off.b989fed2b281ff2ca1d0f792ead68da7.svg";
export { ForwardRef as ReactComponent };